import React from "react";
import { Field, reduxForm } from "redux-form";
import validator from 'validator';
import {renderTextField} from "../helpers/formFields";

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

class AccountForm extends React.Component {

    onSubmit = (formValues) => {
        this.props.onSubmit(formValues);
    }

    render() {
        return (
            <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
                <Grid container spacing={2}>
                <Grid item xs={12}>
                        <Field
                            name="email"
                            id="email"
                            component={renderTextField}
                            label="Email Address"
                            autoComplete="email"
                            // autoFocus
                            margin="normal"
                            required
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                </Grid>
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                >
                    Next
                </Button>
            </form>
        )
    }
}

const validate = (formValues) => {
    const errors = {};

    if (formValues.email) {
        if (!validator.isEmail(formValues.email)) {
            errors.email = 'You must enter a valid email';    
        }
    } 

    return errors;
};

export default reduxForm({
    form: 'accountForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    enableReinitialize : true,
    validate: validate
})(AccountForm);